export default Object.freeze({
    REQUEST_APPROVAL: 'REQUEST_APPROVAL',
    ACCEPTED_BY_DEFAULT: 'ACCEPTED_BY_DEFAULT',
    BLOCK_PUBLIC_RESERVATIONS: 'BLOCK_PUBLIC_RESERVATIONS',
    EXTERNAL_SYSTEM_REGOS: 'EXTERNAL_SYSTEM_REGOS',
})
